// @flow
import { OFFERS_PUSH } from 'Client/cms/toolkit/constants';
import { OffersPushLine } from 'Components/lines/offers-push-line/OffersPushLine';

export const offersPushDescriptor = {
  name: OFFERS_PUSH,
  component: OffersPushLine,
};
